import { Divider, Theme, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { observer } from 'mobx-react';
import React from 'react';

import { ICommonProperties } from '../../../common/properties/ICommonProperties';

export interface IFormTitleTextProperties extends ICommonProperties {
  text: string;
  description?: string;
  extraText?: string
}

export const FormTitleText = observer(({ text, description, extraText }: IFormTitleTextProperties) => {
  const classes = useStyles();

  return (
    <div className={classes.formText}>
      <Typography>{text}</Typography>
      {description && description.length && description.length > 0 && (
        <Typography variant={'subtitle2'}>{description}</Typography>
      )}
      <Divider sx={{my: 0.5, borderColor: 'rgba(255, 255, 255, 0.6)'}} variant="fullWidth" />
      {extraText && <Typography ml={1.5} fontSize='0.75rem' color={'rgba(255, 255, 255, 0.7)'} variant={'subtitle2'}>{extraText}</Typography>}
      
    </div>
  );
});

const useStyles = makeStyles((theme: Theme) => ({
  formText: {
    padding: theme.spacing(1),
    // margin: '10px'
  },
}));
